import AxiosControl from '../components/axios/AxiosControl'
import { getErrorMessage, getResponseData, getResponseMessage, isSuccessResponse } from '../helpers/apiResponse'
const Axios = AxiosControl()

export const getProducts = (page = null, limit = null, search = '', sortBy = null, sortOrder = null) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/product/getAll', {page, limit, search, sortBy, sortOrder}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'PRODUCT_GETALL_SUCCESS',
                payload: getResponseData(data)
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const getProduct = (productId) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/product/get/'+ productId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            const product = getResponseData(data).product
            dispatch({
                type: 'PRODUCT_GET_SUCCESS',
                payload: product
            })
            return product
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const addProduct = (productdata) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/product/create', productdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'PRODUCT_ADD_SUCCESS',
                payload: {
                    ...getResponseData(data),
                    message: getResponseMessage(data)
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const editProduct = (productId, productdata) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/product/edit/'+ productId, productdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            const responseData = getResponseData(data)
            dispatch({
                type: 'PRODUCT_EDIT_SUCCESS',
                payload: {
                    ...responseData,
                    message: getResponseMessage(data)
                }
            })
            return responseData
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR',
            payload: getErrorMessage(error)
        })
    }
}

export const resetProductResult = () => (dispatch) => {
    dispatch({
        type: 'PRODUCT_RESET_RESULT'
    })
}

export const fillProductWithAI = (productId) => async (dispatch) => {
    dispatch({ type: 'PRODUCT_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/product/ai-fill/' + productId, {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            dispatch({
                type: 'PRODUCT_AI_FILL_SUCCESS',
                payload: getResponseData(data)
            })
            return getResponseData(data)
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR',
            payload: 'aiFillUnavailable'
        })
        throw error
    }
}

export const importProducts = (productsData) => async (dispatch) => {
    dispatch({
        type: 'PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/product/import', { rows: productsData }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (isSuccessResponse(status, data)) {
            const responseData = getResponseData(data)
            dispatch({
                type: 'PRODUCT_IMPORT_SUCCESS',
                payload: {
                    ...responseData,
                    message: getResponseMessage(data)
                }
            })
            return responseData
        }
    } catch (error) {
        dispatch({
            type: 'PRODUCT_ERROR',
            payload: getErrorMessage(error)
        })
        throw error
    }
}

export const uploadFile = (file, type = 'document') => async () => {
    const formData = new FormData()
    formData.append(type === 'image' ? 'image' : 'file', file)

    const endpoint = type === 'image'
        ? '/api/upload/uploadimage'
        : '/api/upload/uploaddocument'

    const { data } = await Axios.post(endpoint, formData, {
        headers: { auth: localStorage.getItem('jwt') }
    })
    return data
}